import InfoPage from './InfoPage'

export default InfoPage


// WEBPACK FOOTER //
// ./src/components/InfoPage/index.js